import { AuthenticatedUser } from '@generated/authenticate/src';
import roleEnum from '@utils/roleEnum';

import hasRole from './hasRole';

const isTrainer = (user: AuthenticatedUser | undefined): boolean =>
  hasRole(user, roleEnum.Trainer);

export default isTrainer;
